export function getOrientationFromSize(width, height, threshold) {
    var ratio = width / height;
    if (ratio >= threshold) return "wide";
    return "narrow";
}

//# sourceMappingURL=getOrientationFromSize.js.map